import { useSelector } from 'react-redux'

import { SUPER_ADMIN_WILDCARD } from './types'

import {
  selectPermissions,
  selectIsSuperAdmin,
} from '@/store/slices/authSlice'

/**
 * Returns true when the current admin holds `code`, or is in SUPER_ADMIN (wildcard `*`).
 * Permission codes follow `<SCREEN_CODE>_<ACTION>` (underscore), e.g. `USERS_VIEW`.
 */
export const usePermission = (code: string): boolean => {
  const isSuperAdmin = useSelector(selectIsSuperAdmin)
  const permissions = useSelector(selectPermissions)
  if (isSuperAdmin) return true
  if (permissions.includes(SUPER_ADMIN_WILDCARD)) return true
  return permissions.includes(code)
}

/**
 * Returns true when the admin holds ANY of `codes` (OR-list), or is SuperAdmin.
 * Empty array → false (prevents accidentally-open checks).
 */
export const useAnyPermission = (codes: string[]): boolean => {
  const isSuperAdmin = useSelector(selectIsSuperAdmin)
  const permissions = useSelector(selectPermissions)
  if (isSuperAdmin) return true
  if (permissions.includes(SUPER_ADMIN_WILDCARD)) return true
  if (codes.length === 0) return false
  return codes.some((c) => permissions.includes(c))
}
